<ng-template [uiDrawerTitle]>
  <div class="task-details-title" *ngIf="task">
    <ui-input-text-field
      [(value)]="task.name"
      [maxCharacterCount]="350"
      [uiPlaceholder]="'enter_task_name' | localize"
      [borderless]="true"
      (valueChange)="updateTask($event, 'name')"
      uiType="task"
      uiTheme="fill"
      uiSize="small"></ui-input-text-field>
  </div>
</ng-template>

<ng-template [uiDrawerExtra]>
  <div class="task-details-actions">
    <button [uiDropdownMenu]="menu" ui-button ui-dropdown uiTrigger="click">
      <i ui-icon uiType="menu-horizontal"></i>
    </button>
    <ui-dropdown-menu #menu="uiDropdownMenu">
      <ul ui-menu>
        <li (click)="changeArchivedStatus()" ui-menu-item>
          {{ "archive" | localize }}
        </li>
        <li (click)="cloneTask()" ui-menu-item>
          {{ "clone" | localize }}
        </li>
        <li (click)="deleteTask()" ui-menu-item>
          {{ "delete" | localize }}
        </li>
      </ul>
    </ui-dropdown-menu>
  </div>
</ng-template>
